const BASEPATH = window.__BASEURL__ || '/';
const FEDOPS_APP_NAME = window.__FEDOPS_APP_NAME__ || 'vmaf-client';

export { BASEPATH, FEDOPS_APP_NAME };
